module.exports = __webpack_public_path__ + "img/honda.569ee8c9.png";